export class User {
    Nombre: string;
    Mail: string;
    Telefono: string;
    Mensaje: string;
}
